import { COUNTRIES } from 'react-easyrocket';

export const getCountryNameByAlpha3Code = (code: string, options = COUNTRIES) => {
  return options.find((c) => c.alpha3 === code)?.alpha2;
};
